const blogs = {
  seeMore: "Show more",
  blog: "Blog",
  create: "Create a blog post",
  edit: "Edit blog post",
  latest: "Latest posts",
  postsBlog: "Blog posts",
  link: "Article link",
  preview: "Blog post preview",
  createBlogInstruction:
    "The blog post will appear first on the “In the Media” page.",
  missingDataInLanguages: "Missing data in one or more languages.",
  emptyPage: "There are no articles on this page.",
  blogDetail: "Blog post details",
};

export default blogs;
